import { createFileRoute, redirect } from '@tanstack/react-router'
import { USERS_TAB_PERMISSIONS } from '~/components/routes/users/tabs'
import { withRoutePermissions } from '~/utils/rbac'

/**
 * `/users/bo` — ancienne liste des comptes du back-office (DataGrid MUI), **absorbée** par l'axe
 * « Par utilisateur » de `/administration/access` (spec §3.1).
 *
 * La route est conservée en **redirection** plutôt que supprimée : elle est la cible de liens
 * partagés, de favoris et des `navigate({ to: '/users/bo' })` des écrans de création et d'édition
 * d'un compte. Sa garde reste `read users.bo-users.user`, pour ne pas ouvrir une redirection à qui
 * n'avait pas le droit d'ouvrir la liste.
 *
 * Le nettoyage de la pile MUI (`UsersSearchGrid`, `users-page-layout`, `UserRolesCell`) est le lot
 * U9, post-bascule.
 */
export const Route = createFileRoute('/_authenticated/users/bo')({
  staticData: {
    permission: USERS_TAB_PERMISSIONS.bo,
  },
  beforeLoad: () => {
    throw redirect({ to: '/administration/access' })
  },
})
withRoutePermissions(Route)
